.dealerListItem {
  display: flex;
  column-gap: 8px;
  padding: 8px;
  align-items: center;
  position: relative;

  &.hovered {
    background-color: var(--sparky-grey-100);

    .dealerName {
      color: var(--sparky-navy-400) !important;
    }
  }

  svg {
    min-height: 15px;
    min-width: 15px;
  }

  .dealerName {
    &.hovered {
      max-width: 65%;
    }
  }

  .highlightButton {
    position: absolute;
    right: 8px;
    cursor: pointer;
    margin: auto 0;
    top: 0;
    bottom: 0;
  }
}

.circleIcon {
  svg {
    transform: scale(1.4);
  }
}

.starIcon {
  svg {
    transform: scale(1.2);
  }
}
